// extracted by mini-css-extract-plugin
module.exports = {"container":"buildModeSuggestionsClient_container__u1uEG","suggestionButton":"buildModeSuggestionsClient_suggestionButton__RhwGK"};